module.exports = __webpack_public_path__ + "img/checklist_icon.f94cc416.png";